'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeAnchor = void 0;
var $ = require("jquery");
var FakeAnchor = /** @class */ (function () {
    function FakeAnchor() {
        var self = this;
        $('.trigFakeAnchor').click(function (e) {
            if (!self.allowDefaultEvent(e.target)) {
                e.preventDefault();
                location.href = $(this).data('href');
                return false;
            }
        });
    }
    FakeAnchor.prototype.allowDefaultEvent = function (elm) {
        var allow = false;
        if (elm.tagName === 'A') {
            allow = true;
        }
        else if (elm.className.indexOf('paramAllowDefaultEvent') !== -1) {
            allow = true;
        }
        return allow;
    };
    return FakeAnchor;
}());
exports.FakeAnchor = FakeAnchor;
exports.default = FakeAnchor;
